<template>
  <el-empty v-if="!queryParams.target || !queryParams.mode" />
  <full-container v-else>
    <!--工具条-->
    <div slot="header" class="toolbar">
      <el-form :inline="true" :model="queryParams" size="small" class="search-form">
        <el-form-item>
          <el-input v-model="queryParams.keyword" placeholder="名称关键字" clearable>
            <el-button slot="append" icon="el-icon-search" @click="onSearch()" />
          </el-input>
        </el-form-item>
      </el-form>
      <el-button type="danger" size="small" icon="el-icon-circle-plus" @click="addAction">接口授权</el-button>
    </div>

    <!--表格-->
    <el-table v-loading="loading" ref="tb" :data="datalist.Items" height="100%">
      <el-table-column prop="Method" label="请求类型" min-width="80" show-overflow-tooltip />
      <el-table-column prop="Name" label="接口名称" min-width="100" show-overflow-tooltip />
      <el-table-column prop="Url" label="接口路由" min-width="200" show-overflow-tooltip />
      <el-table-column prop="ModeText" label="授权方式" min-width="80" align="center" show-overflow-tooltip />
      <el-table-column prop="Limits" label="数据限制" min-width="200" show-overflow-tooltip>
        <template slot-scope="{ row }">
          <el-tag effect="plain" size="mini" v-for="(item, index) in row.Limits" :key="index" closable
            @close="removeLimit(row, item)"> {{ item.Text }}={{ item.Value }} </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="设置" align="center" width="60">
        <template slot-scope="{ row }">
          <el-tag effect="plain" size="mini" @click="addLimit(row)"><i class="el-icon-plus" /></el-tag>
        </template>
      </el-table-column>
    </el-table>
    <!--分页-->
    <el-pagination slot="footer" background :page-size="queryParams.size" :total="datalist.TotalCount"
      @current-change="onSearch" />
  </full-container>
</template>


<script>
import setting from './_setting.vue'
import datalimit from './_datalimit.vue'
export default {
  props: {
    mode: { type: Number, default: null },
    target: { type: String, default: null },
  },
  data () {
    return {
      loading: false,
      datalist: [],
      queryParams: {
        index: 1,
        size: 20,
        type: [1],
        mode: this.mode,
        target: this.target
      },
    }
  },
  mounted () {
    this.loadData()
  },
  methods: {
    // 查询参数
    onSearch (val = 1) {
      this.queryParams.index = val
      this.loadData()
    },
    // 信息列表
    loadData () {
      this.loading = true
      this.$apis.system.role.auth.actions(this.queryParams).then((res) => {
        this.datalist = res
      }).catch((e) => {
        this.$message.error(e)
      }).finally(() => {
        this.loading = false
      })
    },

    //添加接口权限
    addAction () {
      this.$layer.iframe({
        title: `添加接口授权`,
        area: ['720px', '600px'],
        content: {
          content: setting,
          parent: this,
          data: {
            mode: this.queryParams.mode,//角色
            targetId: this.queryParams.target,
          }
        }
      })
    },

    //添加数据限制
    addLimit (row) {
      this.$layer.iframe({
        title: `${row.Name}-数据限制`,
        area: ['400px', 'auto'],
        content: {
          content: datalimit,
          parent: this,
          data: {
            mode: this.queryParams.mode,
            target: this.queryParams.target,
            action: row.Action,
            callback: this.loadData
          }
        }
      })
    },
    //移除限制
    removeLimit (row, item) {
      this.loading = true
      this.$apis.system.role.limit.delete({
        id: item.Id
      }).then(() => {
        row.Limits.splice(row.Limits.findIndex(x => x.id === item.id), 1)
      }).catch(e => {
        this.$message.error(e || "执行错误")
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>
